var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hours"},[_c('statisticCard',{attrs:{"icon":'mdi-clock-time-two',"color":'green',"statistic":_vm.getCount(_vm.statistic.from_start_count),"description":'שעות לימוד'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }